import React, { Component, createRef } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import Row from "../common/layout/row";
import Content from "../common/template/content";
import TipoAposta from "../common/widget/tipoAposta";

import ConcursoInput from "./concursoInput";
import { init, selectConcursoType } from "../reducers/concurso/concursoActions";
import Apostas from "../relatorios/suasapostas";
import Resultados from "../relatorios/resultados";
import Extracoes from "../relatorios/extracoes";
import Loteria from "../loteria/loteria";
import Rifa from "../rifa/rifa";
import { getPreTickets, hasPreTicketEnabled } from "../utils/getPreTickets";
import PreTicketList from "../rifa/components/preTicketList";

const RENDER_LIST = 0;
const RENDER_CONCURSO = 1;
const RENDER_MINHASAPOSTAS = 2;
const RENDER_MODALIDADE = 3;
const RENDER_RESULTADO = 4;
const RENDER_EXTRACOES = 5;
const RENDER_RIFA = 6;

class Concurso extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showPreTickets: false
    }

    this.topRef = createRef(null);
  }
  
  componentWillMount() {
    this.props.init();
  }

  componentDidUpdate() {
    if (!!this.props.preSelected && !this.props.concursoType) {
      const list = this.getListConc();
      if (list && list.length) {
        const preselected = list.find(
          (item) =>
            item.objTipoJogo &&
            (item.objTipoJogo.vchSigla || "").toLowerCase() ===
              (this.props.preSelected || "").toLowerCase()
        );
        if (preselected) {
          this.props.selectConcursoType(preselected);
        }
      }
    }
  }
  renderConcursoInput() {
    return <ConcursoInput 
    toggleErrorModal={this.props.toggleErrorModal} concursoType={this.props.concursoType} topRef={this.topRef}/>;
  }

  renderMinhasApostas() {
    return <Apostas />;
  }

  verificaFluxoRepeticao() {
    var returnIndex = 0;
    let arr = this.props.arrRepeticao;
    var tip = null;
    let list = this.props.objUser.arrTipoJogo || [];

    if ([555, 666, 1515].includes(arr[0].sntTipoJogo)) {
      let listConc =
        list.filter(
          (conc) =>
            conc.objTipoJogo.bitConcurso == 1 &&
            conc.objTipoJogo.sntTipoJogo == arr[0].sntTipoJogo
        ) || [];
      if (listConc.length > 0) {
        tip = listConc[0];
        returnIndex = RENDER_CONCURSO;
      }
    } else {
      let listModalidade =
        list.filter((conc) => conc.objTipoJogo.bitConcurso == 0) || [];
      if (listModalidade.length > 0) {
        tip = {
          intCodigoRetorno: 0,
          objTipoJogo: {
            sntTipoJogo: 3,
            vchSigla: "W",
            vchNome: "Loterias",
            listModalidade: listModalidade,
          },
        };
        returnIndex = RENDER_MODALIDADE;
      }
    }

    this.props.selectConcursoType(tip);
    return returnIndex;
  }

  renderResultados() {
    return <Resultados />;
  }

  renderExtracoes() {
    return <Extracoes />;
  }

  renderModalidade() {
    return <Loteria />;
  }

  renderPreTickets() {
    return <PreTicketList user={this.props.objUser} />
  }

  getListConc() {
    const list = this.props.objUser.arrTipoJogo || [];

    if (typeof this.props.objUser.arrTipoJogo === "undefined") return [];

    //Ainda não terá a modalidade Time Certo ( id = 8888)
    const listConc =
      list.filter(
        (conc) =>
          conc.objTipoJogo.bitConcurso == 1 &&
          conc.objTipoJogo.TipoJogoCategoria_ID != 7
      ) || [];

    if (this.props.objUser.TokenLE != "") {
      var minhasApostas = {
        intCodigoRetorno: 0,
        objTipoJogo: {
          sntTipoJogo: 0,
          vchSigla: "A",
          vchNome: "Minhas Apostas",
        },
      };
      listConc.push(minhasApostas);
    }

    const listModalidade =
      list.filter((conc) => conc.objTipoJogo.bitConcurso == 0) || [];
    if (listModalidade && listModalidade.length > 0) {
      var apostaModalidade = {
        intCodigoRetorno: 0,
        objTipoJogo: {
          sntTipoJogo: 3,
          vchSigla: "W",
          vchNome: "Loterias",
          listModalidade: listModalidade,
        },
      };
      listConc.push(apostaModalidade);
    }

    var resultados = {
      intCodigoRetorno: 0,
      objTipoJogo: { sntTipoJogo: 0, vchSigla: "R", vchNome: "Resultados" },
    };
    listConc.push(resultados);

    var extracoes = {
      intCodigoRetorno: 0,
      objTipoJogo: { sntTipoJogo: 0, vchSigla: "E", vchNome: "Extracoes" },
    };
    listConc.push(extracoes);

    if (
      window["wweb-session"] &&
      window["wweb-session"].objRifas.arrRifas.length
    ) {
      var rifa = {
        intCodigoRetorno: 0,
        objTipoJogo: { sntTipoJogo: 999999, vchSigla: "R1", vchNome: "Rifa" },
      };
      listConc.push(rifa);
    }

    const preTickets = getPreTickets();
    if (
      hasPreTicketEnabled() && preTickets && preTickets.length
    ) {
      listConc.push({
        intCodigoRetorno: 0,
        objTipoJogo: { sntTipoJogo: 0, vchSigla: "PT", vchNome: "Pré-Tickets" },
        isPreTickets: true
      });
    }

    return listConc;
  }

  renderList() {
    return this.getListConc().map((tip) => (
      <TipoAposta
        key={tip.objTipoJogo.sntTipoJogo}
        title={tip.objTipoJogo.vchSigla}
        tipo={tip.objTipoJogo.sntTipoJogo}
        name={tip.objTipoJogo.vchNome}
        onClick={() => {
          if (tip.isPreTickets) this.setState({showPreTickets: true});
          else this.props.selectConcursoType(tip);
        }}
      />
    ));
  }

  renderCurrentScreen() {
    if (this.state.showPreTickets) {
      return this.renderPreTickets();
    }

    var renderIndex = this.props.concursoScreen;
    if (this.props.arrRepeticao && this.props.arrRepeticao.length > 0) {
      renderIndex = this.verificaFluxoRepeticao();
    }

    switch (renderIndex) {
      case RENDER_LIST:
        return this.renderList();
      case RENDER_CONCURSO:
        return this.renderConcursoInput();
      case RENDER_MINHASAPOSTAS:
        return this.renderMinhasApostas();
      case RENDER_MODALIDADE:
        return this.renderModalidade();
      case RENDER_RESULTADO:
        return this.renderResultados();
      case RENDER_EXTRACOES:
        return this.renderExtracoes();
      case RENDER_RIFA:
        return this.renderRifa();
      default:
        return this.renderList();
    }
  }

  renderRifa() {
    return (
      <Content>
        <Rifa toggleErrorModal={this.props.toggleErrorModal}/>
      </Content>
    );
  }

  render() {
    // const list = this.props.objUser.arrTipoJogo || []
    // //const i = list.findIndex(tp => tp.objTipoJogo.sntTipoJogo === this.props.ProdutoID);
    // const i = list.findIndex(tp => tp.objTipoJogo.sntTipoJogo === 0);
    // this.props.selectConcursoType(list[i]);
    let currentScreen = this.renderCurrentScreen();
    // currentScreen = null
    let loader = currentScreen ? null : <div className="loader"></div>;

    return (
      <Content>
        <div ref={this.topRef}></div>
        <Row>{currentScreen}</Row>
        {/* <Row> */}
        {loader}
        {/* </Row>  */}
      </Content>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    objUser: state.usuario.objUser,
    concursoScreen: state.concurso.concursoScreen,
    concursoType: state.concurso.concursoType,
    arrApostas: state.carrinho.arrApostas,
    arrRepeticao: state.repeticao.arrAposta,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ init, selectConcursoType }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Concurso);



// WEBPACK FOOTER //
// ./src/concurso/concurso.jsx